export interface ThemeShowcaseGridRow {
  id: number;
  name: string;
  city: string;
  isActive: boolean;
  users: number;
}

export interface ShowcaseOption {
  label: string;
  value: string;
}

export const themeShowcaseGridData: ThemeShowcaseGridRow[] = [
  { id: 1, name: 'Alpine Retail', city: 'Zurich', isActive: true, users: 24 },
  { id: 2, name: 'Northwind Logistics', city: 'Bern', isActive: true, users: 12 },
  { id: 3, name: 'Contoso Healthcare', city: 'Basel', isActive: false, users: 7 },
  { id: 4, name: 'Fabrikam Services', city: 'Lugano', isActive: true, users: 30 },
  { id: 5, name: 'Woodgrove Energy', city: 'Winterthur', isActive: false, users: 5 },
  { id: 6, name: 'Adventure Works', city: 'Lucerne', isActive: true, users: 16 }
];

export const themeShowcaseClientOptions: ShowcaseOption[] = [
  { label: 'Alpine Retail', value: 'alpine' },
  { label: 'Northwind Logistics', value: 'northwind' },
  { label: 'Contoso Healthcare', value: 'contoso' }
];

export const themeShowcaseLocationOptions: string[] = [
  'Zurich HQ',
  'Bern Office',
  'Basel Warehouse',
  'Lugano Branch'
];
